<template>
  <!-- 分納資訊 -->
  <div>
    <div class="row col-12">
      <!-- <q-toggle class="row col-6 justify-start" v-model="expandInsFlag" @input="openInsExpand()" color="blue" label="合/開"/> -->
      <q-item class="col-12 row justify-end text-h6 text-bold text-blue-10" bordered>訂單號碼 {{cordNo}}</q-item>
    </div>
    <q-scroll-area style="height: 20em;" :content-style="contentStyle" :content-active-style="contentActiveStyle">
      <q-list class="rounded-borders"  bordered v-for="(c, index) in installments" :key="index">
          <!-- 角色不為B 經銷商使用 無生產資訊日期 -->
        <q-item v-if="isAllow('IS_ALL_EXPAND') !== 'Y'" class="text-h5 text-weight-bold" :style="{backgroundColor: insNo === c.deliverySeq.toString() ? '#a2dce8': '' }">
          <template class="text-center">
          <q-item-section avatar>
              <q-avatar icon="fab fa-elementor" color="primary" text-color="white" />
          </q-item-section>
          <q-item-section class="justify-center">
              <q-btn desc flat class="text-h5 col-10" align="left" push color="primary" style="box-shadow:none; font-size:1em; margin-bottom:0px;padding:0px" :label="'分納' + c.deliverySeq" @click="openWindow(c)"></q-btn>
          </q-item-section>
          <q-item-section side>
              <div class="row items-center">
              {{c.deliveryDate}}
              </div>
              <q-menu content-class="q-pa-xs bg-primary text-white" touch-position>預計交期</q-menu>
          </q-item-section>
          </template>
        </q-item>
        <!-- 角色為B YKK內勤人員 -->
        <q-expansion-item v-else-if="isAllow('IS_ALL_EXPAND') === 'Y'" class="text-h5 text-weight-bold" :header-style="{backgroundColor: insNo === c.deliverySeq.toString() ? '#a2dce8': '' }" group="somegroup" v-model="insExpanded[index]" icon="fas fa-clipboard" header-class="text-blue-9">
          <template v-slot:header class="text-center">
            <q-item-section avatar>
              <q-avatar icon="fab fa-elementor" color="primary" text-color="white" />
            </q-item-section>
            <q-item-section class="justify-center">
              <q-btn desc flat class="text-h5 col-10" align="left" push color="primary" style="box-shadow:none; font-size:1em; margin-bottom:0px;padding:0px" :label="'分納' + c.deliverySeq" @click="openWindow(c)"></q-btn>
            </q-item-section>
            <q-item-section side>
              <div class="row items-center">
              {{c.deliveryDate}}
              <q-menu content-class="q-pa-xs bg-primary text-white" touch-position>預計交期</q-menu>
              </div>
            </q-item-section>
          </template>
          <q-item>
            <q-item-section class="text-weight-bold text-black text-h6">
              <q-item-label style="max-height: 9.6em;">
                <div class="row col-12">
                  <div class="col-6">
                  切斷起始日：
                  </div>
                  <div class="col-6">
                  {{c.cutStartDate}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-6">
                  切斷完成日：
                  </div>
                  <div class="col-6">
                  {{c.cutEndDate}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-6">
                  加工起始日：
                  </div>
                  <div class="col-6">
                  {{c.machiningStartDate}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-6">
                  加工完成日：
                  </div>
                  <div class="col-6">
                  {{c.machiningEndDate}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-6">
                  包裝起始日：
                  </div>
                  <div class="col-6">
                  {{c.packingStartDate}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-6">
                  包裝入庫日：
                  </div>
                  <div class="col-6">
                  {{c.packingEndDate}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-6">
                  出庫日：
                  </div>
                  <div class="col-6">
                  {{c.shipStartDate}}
                  </div>
                </div>
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-expansion-item>
      </q-list>
    </q-scroll-area>
  </div>
</template>
<script type="text/javascript">
import { commonMixin } from '@/common/js/mixins'

export default {
  name: 'Installment',
  props: {
    cordNo: {
      type: String,
      default: ''
    },
    insNo: {
      type: String,
      default: ''
    },
    insFlag: {
      type: Boolean,
      default: false
    }
  },
  mixins: [commonMixin],
  components: {},
  watch: {
    'cordNo' (nval, oval) {
      if (nval !== '') {
        this.updateInstallment()
      }
    }
  },
  computed: {
    contentStyle () {
      return {
        backgroundColor: 'rgba(0,0,0,0.02)',
        color: '#555'
      }
    },

    contentActiveStyle () {
      return {
        backgroundColor: '#eee',
        color: 'black'
      }
    }
  },
  mounted () {
  },
  created () {
    // 取得角色類型
    this.roleType = this.$store.getters.getCurrentUserRoleType
  },
  data () {
    return {
      expandInsFlag: true,
      insExpanded: [],
      // 分納資訊
      installments: [],
      roleType: ''
    }
  },
  methods: {
    // 分納
    openWindow (insatllmentObject) {
      // 更新 目前選取的分納
      this.$emit('update:insNo', insatllmentObject.deliverySeq.toString())
      console.log('openWindow')
    },
    updateInstallment () {
      this.installments = []
      this.post('getInsDetail', { cordNo: this.cordNo, roleType: this.roleType }, r => {
        if (r.length > 0) {
          // 開啟此區塊
          this.$emit('update:insFlag', true)
          this.installments = r
          // 預設全部收起
          this.insExpanded = []
          this.installments.forEach(p => {
            this.insExpanded.push(false)
          })
        } else {
          this.message('此訂單編號查無分納')
          // 隱藏此區塊
          this.$emit('update:insFlag', false)
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
